var Funcionalidades = [
    {
        Perfil: "Gestor",
        Permissoes: [
            { name: "Pesquisa de Ordens", path: "ordemserviçopesquisa" },
            { name: "Lista de Ordens do Dashboard", path: "analiseordem" },
            { name: "Mapa de Análise de Ordem", path: "analiseordemmap" },
            { name: "Monitoramento de Ordem", path: "monitoramento" },
            { name: "Divisão Administrativa", path: "divisaoadministrativa" },
            { name: "Áreas Operacionais", path: "areasoperacionais" },
            { name: "Modalidades de Serviço", path: "modalidadesservico" },
            { name: "Concessionárias", path: "concessionarias" },
            { name: "Recursos", path: "recursos" },
            { name: "Locais de Execução", path: "localexecucao" },
            { name: "Planos de Trabalho", path: "planostrabalho" },
            { name: "Justificativas", path: "justificativa" },
            { name: "Destinos", path: "destino" },
            { name: "Usuários", path: "usuarios" },
            { name: "Historico do locais de execução", path: "historico" },
            { name: "Relatórios", path: "relatorios" },
            { name: "Cadastro de Setores", path: "delimitacaoGeografica" },
            { name: "Cadastro de Índice de Qualidade", path: "indiceQualidade" },
            { name: "Cadastro de Índice de Atendimento", path: "indiceAtendimento" },
        ],
        PermissoesEspeciais: [
            { name: "Incluir Inconformidades na Ordem de Serviço", permissao: "add_inconformidades_os" },
            { name: "Contestar Ordem de Serviço", permissao: "contestar_os" },
            { name: "Aprovar Ordem de Serviço", permissao: "aprovar_os" },
            { name: "Reprovar Ordem de Serviço", permissao: "reprovar_os" },
            { name: "Visualiza Notificações de Alertas de Inconformidade", permissao: "visualizar_alertas_os" }
        ],
        Relatorios: [
            { name: "Relatório de Produtividade Analítico", permissao: "relatorio_produtividadeAnalitico" },
            { name: "Relatório de Produtividade Sintético", permissao: "relatorio_produtividadeSintetico" },
            { name: "Relatório de Inconformidades", permissao: "relatorio_inconformidades" },
            { name: "Relatório de Ocorrências", permissao: "relatorio_Ocorrencias" },
            { name: "Relatório de Atendimento Analítico", permissao: "relatorio_atendimentoAnalitico" },
            { name: "Relatório de Atendimento Sintético", permissao: "relatorio_atendimentoSintetico" },
            { name: "Relatório de Qualidade Analítico", permissao: "relatorio_qualidadeAnalitico" },
            { name: "Relatório de Qualidade Sintético", permissao: "relatorio_qualidadeSintetico" },
            { name: "Relatório de Histórico de Atendimento dos Pontos de Coleta", permissao: "relatorio_historicoAtendimentoPontoColeta" }
        ]
    },
    {
        Perfil: "Adm",
        Permissoes: [
            { name: "Programação de Serviço", path: "programacao" },
            { name: "Pesquisa de Ordens", path: "ordemserviçopesquisa" },
            { name: "Lista de Ordens do Dashboard", path: "analiseordem" },
            { name: "Mapa de Análise de Ordem", path: "analiseordemmap" },
            { name: "Monitoramento de Ordem", path: "monitoramento" },
            { name: "Planos de Trabalho", path: "planostrabalho" },
            { name: "Locais de Execução", path: "localexecucao" },
            { name: "Recursos", path: "recursos" },
            { name: "Justificativas", path: "justificativa" },
            { name: "Destinos", path: "destino" },
            { name: "Usuários", path: "usuarios" },
            { name: "Historico do locais de execução", path: "historico" },
            { name: "Cadastro de Setores", path: "delimitacaoGeografica" },
            { name: "Relatórios", path: "relatorios" },
            { name: "Download APP", path: "downloadapp" }
        ],
        PermissoesEspeciais: [
            { name: "Justificar Ordem de Serviço", permissao: "justificar_os" },
            { name: "Incluir Ocorrência na Ordem de Serviço", permissao: "add_ocorrencias_os" },
            { name: "Visualiza Notificações de Alertas de Inconformidade", permissao: "visualizar_alertas_os" }
        ],
        Relatorios: [
            { name: "Relatório de Produtividade Analítico", permissao: "relatorio_produtividadeAnalitico" },
            { name: "Relatório de Produtividade Sintético", permissao: "relatorio_produtividadeSintetico" },
            { name: "Relatório de Inconformidades", permissao: "relatorio_inconformidades" },
            { name: "Relatório de Ocorrências", permissao: "relatorio_Ocorrencias" },
            { name: "Relatório de Atendimento Analítico", permissao: "relatorio_atendimentoAnalitico" },
            { name: "Relatório de Atendimento Sintético", permissao: "relatorio_atendimentoSintetico" },
            { name: "Relatório de Qualidade Analítico", permissao: "relatorio_qualidadeAnalitico" },
            { name: "Relatório de Qualidade Sintético", permissao: "relatorio_qualidadeSintetico" },
            { name: "Relatório de Histórico de Atendimento dos Pontos de Coleta", permissao: "relatorio_historicoAtendimentoPontoColeta" }
        ]
    },
    {
        Perfil: "Supervisor",
        Permissoes: [
            { name: "Programação de Serviço", path: "programacao" },
            { name: "Pesquisa de Ordens", path: "ordemserviçopesquisa" },
            { name: "Lista de Ordens do Dashboard", path: "analiseordem" },
            { name: "Mapa de Análise de Ordem", path: "analiseordemmap" },
            { name: "Monitoramento de Ordem", path: "monitoramento" },
            { name: "Planos de Trabalho", path: "planostrabalho" },
            { name: "Locais de Execução", path: "localexecucao" },
            { name: "Recursos", path: "recursos" },
            { name: "Justificativas", path: "justificativa" },
            { name: "Destinos", path: "destino" },
            { name: "Usuários", path: "usuarios" }
        ],
        PermissoesEspeciais: [
            { name: "Justificar Ordem de Serviço", permissao: "justificar_os" },
            { name: "Incluir Ocorrência na Ordem de Serviço", permissao: "add_ocorrencias_os" },
            { name: "Visualiza Notificações de Alertas de Inconformidade", permissao: "visualizar_alertas_os" }
        ]
    },
    {
        Perfil: "Encarregado de Monitoramento",
        Permissoes: [
            { name: "Pesquisa de Ordens", path: "ordemserviçopesquisa" },
            { name: "Lista de Ordens do Dashboard", path: "analiseordem" },
            { name: "Mapa de Análise de Ordem", path: "analiseordemmap" },
            { name: "Monitoramento de Ordem", path: "monitoramento" },
        ],
        PermissoesEspeciais: [
            { name: "Incluir Inconformidades na Ordem de Serviço", permissao: "add_inconformidades_os" },
            { name: "Contestar Ordem de Serviço", permissao: "contestar_os" },
            { name: "Aprovar Ordem de Serviço", permissao: "aprovar_os" },
            { name: "Reprovar Ordem de Serviço", permissao: "reprovar_os" },
            { name: "Visualiza Notificações de Alertas de Inconformidade", permissao: "visualizar_alertas_os" }
        ]
    }
];
export default Funcionalidades;